<template>
  <div class="bg-primary-blue fixed bottom-0 w-full left-0">
    <nav class="flex flex-row sm:flex-row justify-around max-w-md mx-auto">
      <RouterLink v-wave to="/app/receipts" class="w-1/2 flex flex-col pb-2 pt-3" data-cy="receipt-nav-item">
        <font-awesome-icon icon="fa-solid fa-receipt" class="text-blue-400 pb-1 text-lg" />
        <a class="text-blue-400 text-sm px-6 block text-center">
          {{ $t('BottomNavbar.Receipts') }}
        </a>
      </RouterLink>
      <RouterLink v-wave to="/app/account" class="w-1/2 flex flex-col pb-2 pt-3" data-cy="account-nav-item">
        <font-awesome-icon icon="fa-solid fa-user" class="text-blue-400 pb-1 text-base" />
        <a class="text-blue-400 text-sm px-6 block text-center">
          {{ $t('BottomNavbar.Account') }}
        </a>
      </RouterLink>
    </nav>
  </div>
</template>

<style scoped lang="scss">
.router-link-active {
  a,
  svg {
    font-weight: 500;
    color: white;
  }
}
</style>
